import {Component, ElementRef, OnInit} from '@angular/core';
import {ThemeService} from '../../services/theme.service';
import {ConfigureService} from "../../../../../projects/common/modules/configure/configure.service";

@Component({
    selector: 'app-theme-picker',
    templateUrl: './theme-picker.component.html',
    styleUrls: ['./theme-picker.component.scss'],
    standalone: false
})
export class ThemePickerComponent implements OnInit {
  public overlayIsOpen: boolean;
  public theme = this.themeService.theme;
  public themeName = this.themeService.theme;

  public themes = this.themeService.themes;

  constructor(private themeService: ThemeService, private element: ElementRef, private config: ConfigureService) {
    // console.log(this.theme.getValue());
  }

  public clickedOutsideOverlay(event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.overlayIsOpen = false;
    }
  }

  public setTheme(theme) {

    this.themeService.setTheme(theme, this.config.options.appCode);
    this.overlayIsOpen = false;
  }

  ngOnInit() {
    return;
  }

}

